var map = {
	"./0.jpg": 844,
	"./1.jpg": 202,
	"./2.jpg": 726,
	"./3.jpg": 417,
	"./4.jpg": 957,
	"./5.jpg": 220,
	"./6.jpg": 438,
	"./7.jpg": 98,
	"./8.jpg": 516,
	"./9.jpg": 163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 770;